import { render, staticRenderFns } from "./messageModal.vue?vue&type=template&id=a999a91e&scoped=true&"
import script from "./messageModal.vue?vue&type=script&lang=js&"
export * from "./messageModal.vue?vue&type=script&lang=js&"
import style0 from "./messageModal.vue?vue&type=style&index=0&id=a999a91e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a999a91e",
  null
  
)

export default component.exports